(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["b2b-product-hub"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const button = event.target.closest('[data-hub-tab]');
  if (!button) return;
  const hub = button.closest('[data-product-hub]');
  const target = button.dataset.hubTab;
  hub.querySelectorAll('[data-hub-tab]').forEach((tab) => tab.setAttribute('aria-selected', String(tab === button)));
  hub.querySelectorAll('[data-hub-panel]').forEach((panel) => {
    const active = panel.dataset.hubPanel === target;
    panel.hidden = !active;
    panel.classList.toggle('is-active', active);
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["b2b-reference-catalog"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-b2b-catalog]').forEach((catalog) => {
    const cards = Array.from(catalog.querySelectorAll('[data-b2b-catalog-card]'));
    const filters = Array.from(catalog.querySelectorAll('[data-b2b-catalog-filter]'));
    const search = catalog.querySelector('[data-b2b-catalog-search]');
    const more = catalog.querySelector('[data-b2b-catalog-more]');
    const count = catalog.querySelector('[data-b2b-catalog-count]');
    const step = Number(catalog.dataset.initialCount) || 12;
    let active = 'all';
    let mode = 'solution';
    let visible = step;
    const update = () => {
      const query = search.value.trim().toLowerCase();
      const matches = cards.filter((card) => {
        const category = card.dataset.category;
        const dosageMatch = category === active || (active === 'Capsules & softgels' && (category === 'Capsules' || category === 'Softgels'));
        return (active === 'all' || (mode === 'solution' ? card.dataset.solutions.split(',').includes(active) : dosageMatch)) && (!query || card.dataset.search.includes(query));
      });
      cards.forEach((card) => { card.hidden = true; });
      matches.slice(0, visible).forEach((card) => { card.hidden = false; });
      count.textContent = `${Math.min(visible, matches.length)} / ${matches.length}`;
      more.hidden = visible >= matches.length;
    };
    filters.forEach((button) => button.addEventListener('click', () => {
      active = button.dataset.b2bCatalogFilter;
      visible = step;
      filters.forEach((item) => item.classList.toggle('is-active', item === button));
      update();
    }));
    catalog.querySelectorAll('[data-b2b-catalog-mode]').forEach((button) => button.addEventListener('click', () => {
      mode = button.dataset.b2bCatalogMode;
      active = 'all';
      visible = step;
      catalog.querySelectorAll('[data-b2b-catalog-mode]').forEach((item) => item.classList.toggle('is-active', item === button));
      catalog.querySelectorAll('[data-b2b-catalog-filters-solution],[data-b2b-catalog-filters-dosage]').forEach((group) => { group.hidden = (mode === 'solution') !== group.hasAttribute('data-b2b-catalog-filters-solution'); });
      filters.forEach((item) => item.classList.toggle('is-active', item.dataset.b2bCatalogFilter === 'all'));
      update();
    }));
    search.addEventListener('input', () => { visible = step; update(); });
    more.addEventListener('click', () => { visible += step; update(); });
    update();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
